import React from 'react'
import styled from 'styled-components'

const NewsLetter = () => {
  return (
    <NewsLetterWrapper>
      <div className="head">
        <span>|| Stay Connected</span>
        <h1>Subscribe To Our Newsletter</h1>
        <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Corrupti sequi quae expedita fugiat esse magni.</p>
      </div> 
      <div className="form-container">
        <form>
            <div className="in-box">
                <input type="email" name='email' placeholder='Enter your email address' />
                <button type='button'>Subscribe</button>
            </div>
        </form>
      </div> 
    </NewsLetterWrapper>
  )
}

const NewsLetterWrapper = styled.section`
  min-height: 50vh;
  padding: 100px 20px;

  .head{
    width: 60%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    span{
        color: var(--bg-color);
        font-weight: 700;
    }

    h1{
        padding: 15px 0;
        font-size: 2.3rem;
        font-weight: 700;
    }

    p{
        max-width: 480px;
        text-align: center;
        font-size: 1.04rem;
        font-weight: 600;
        color: var(--text-color);
        line-height: 1.7;
    }
  }

  .form-container{
    width: 50%;
    margin: 2% auto;

    .in-box{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        input, button{
            width: 60%;
            padding: 15px 10px;
            font-size: 16px;
            font-weight: 600;
            border-radius: 5px 0 0 5px;
            box-shadow: 0 0 5px var(--bga-color);
        }
        button{
         width: 22%;
         border-radius: 0 5px 5px 0; 
         background: var(--bg-color);
         cursor: pointer;
         color: var(--main-color);
         font-weight: 700;
        }
    }
  }

  @media screen and (max-width: 884px){
     .head{
       width: 100%;
       h1{
        font-size: 2.6rem;
        text-align: center;
       }
       p{
        font-size: 16px;
       }
     }
    .form-container{
      width: 100%;
      .in-box{
        input{
          width: 50%;
        }
        button{
          width: 20%;
        }
      }
    }
  }

  @media screen and (max-width: 768px){
     .head{
       width: 100%;
       h1{
        font-size: 2rem;
        text-align: center;
       }
       p{
        font-size: 16px;
       }
     }
    .form-container{
      width: 100%;
      .in-box{
        input{
          width: 50%;
        }
        button{
          width: 20%;
        }
      }
    }
  }

  @media screen and (max-width: 430px){
     .head{
       width: 100%;
       h1{
        font-size: 2rem;
        text-align: center;
       }
       p{
        font-size: 16px;
       }
     }
    .form-container{
      width: 100%;
      .in-box{
        input{
          width: 80%;
        }
        button{
          width: 40%;
        }
      }
    }
  }
`

export default NewsLetter